import axios from "axios"
import { GetEmployeeInformationInterface } from "@type/employees.types"
const ROOT_PATH = "employees/information"

export default class EmployeesInformationService {
	static getEmployeesInformationByLocation = (
		locationId: string,
		dates: { startTime: string; finishTime: string }[],
		options: { limit: number; offset: number },
	) =>
		axios.post<{ employees: Array<GetEmployeeInformationInterface>; pageResults: number }>(
			`${ROOT_PATH}/${locationId}?offset=${options.offset}&limit=${options.limit}`,
			dates,
		)
}
